define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/query",
	"dgrid/OnDemandGrid",
	"dgrid/editor",
	"dgrid/tree",
	"dgrid/extensions/DijitRegistry",
	"dijit/registry",
	"csi",
	"csi/_base/underscore",
	"csi/comm/GetRequest",
	"csi/comm/PostRequest",
	"csi/def",
	"csi/def/Action",
	"csi/def/Toolbar",
	"csi/locale",
	"csi/view/ToolbarPluginSelect",
	"csi/view/Widget",
	"csi/widget/CheckBox",
	"./LicenseFeatureMatrix",
	"./LicenseViewFeatureMatrixStore"
], function(declare, lang, query, OnDemandGrid, editor, tree, GridDijitRegistry, registry, csi, _, GetRequest, PostRequest,
	def, Action, Toolbar, locale, ToolbarPluginSelect, ViewWidget, CheckBox, LicenseFeatureMatrix, LicenseViewFeatureMatrixStore) {

	var filterClassForToolbarDropdown = function(rc) {
		return !rc.abstractOrDisabled;
	};

	var columnCheckOnEditTextOnRead = function(view, labelResource, field) {
		return editor({
			autoSave: true,
			canEdit: function() {
				return view._bEditable;
			},
			className: "csi-grid-checkbox",
			editor: CheckBox,
			editorArgs: {},
			field: field,
			label: locale.resource(labelResource),
			sortable: false
		});
	};

	return declare(ViewWidget, {
		plugins: [],
		_grid: null,

		// String: type of node being configured
		_typeNode: "_CS_Data",

		// String: view id for root views of node type
		_rootViewId: "__Host__",

		_bEditable: false,

		postMixInProperties: function() {
			// summary: initialize members and globals - use resolver cache so
			// that changes are reflected in cache
			this.defView.defToolbar = lang.mixin(new Toolbar(), {
				m_actions: this._getToolbarActions()
			});

			this.inherited(arguments);
		},

		_getToolbarActions: function() {
			// summary: return list of toolbar actions
			return [lang.mixin(new Action(), {
				m_id: "ViewConfigSelectType",
				m_onAction: "_onType",
				classToolbarPlugin: ToolbarPluginSelect,
				classToolbarPluginParams: {
					showLabel: true,
					store: def.getPortalTypeStore(this._rootViewId, filterClassForToolbarDropdown),
					value: this._typeNode
				}
			}), "refresh", lang.mixin(new Action(), {
				m_id: "LicenseViewDownloadFeatureMatrix",
				m_onAction: "_onDownloadFeatureMatrix"
			})

			];
		},

		_buildView: function() {
			// summary: create and set store based on plugin parameters
			var store = new LicenseViewFeatureMatrixStore({
				_rootNodeType: this._typeNode,
				_rootViewId: this._rootViewId
			});
			this._bEditable = false;

			if (this._grid) {
				this._grid.set("store", store);
			} else {
				this._grid = new (declare([OnDemandGrid, GridDijitRegistry]))({
					"class": "csi-grid-tableView csi-grid-views",
					showFooter: true,
					query: {
						parent: null
					},
					store: store,
					columns: [tree({
						className: "left",
						field: "name",
						label: locale.resource("View"),
						sortable: false,
						shouldExpand: function(row, level, previouslyExpanded) {
							return previouslyExpanded || !row.data.parent;
						}
					}), {
						className: "left",
						field: "target",
						label: locale.resource("TargetClass"),
						sortable: false
					}, columnCheckOnEditTextOnRead(this, "LicenseConfig:Good", "good"),
					columnCheckOnEditTextOnRead(this, "LicenseConfig:Better", "better"),
					columnCheckOnEditTextOnRead(this, "LicenseConfig:Best", "best"),
					columnCheckOnEditTextOnRead(this, "LicenseConfig:Development", "development")]
				}, this.contentNode);
				this._grid.on("dgrid-datachange", lang.hitch(this, this._onDataChange));
			}
			this._requestForFeatureMatrix(store);
			this.inherited(arguments);
		},

		_onDataChange: function(evt) {
			var b = evt.value;
			var attr = evt.cell.column.field;
			var item = evt.cell.row.data;

			var row = evt.cell.row;
			if (!row.element)
				return;

			// [YG] It works correctly if changes are recursively propagated.
			switch (attr) {
				case "good":
					item.good = b;
					if (b)
						this._propagateCheckBoxChange(row, 1, true, item);
					else
						this._updateServerFor(item);
					break;
				case "better":
					item.better = b;
					if (b)
						this._propagateCheckBoxChange(row, 2, true, item);
					else
						this._propagateCheckBoxChange(row, 0, false, item);
					break;
				case "best":
					item.best = b;
					if (b)
						this._propagateCheckBoxChange(row, 3, true, item);
					else
						this._propagateCheckBoxChange(row, 1, false, item);
					break;
				case "development":
					item.development = b;
					if (b)
						this._updateServerFor(item);
					else
						this._propagateCheckBoxChange(row, 2, false, item);
			}
			;
		},

		_propagateCheckBoxChange: function(/* dgrid row */row, /* integer 0-base */index, /* boolean */newValue, /* store item */item) {
			var checkBoxes = query(".dijitCheckBox", row.element);
			var checkBox = registry.byNode(checkBoxes[index]);
			var oldValue = checkBox.get("value");

			if (oldValue ? !newValue : newValue) /* XOR is change required */
				checkBox.set("value", newValue);
			else
				this._updateServerFor(item);
		},

		_requestForFeatureMatrix: function(/* LicenseViewFeatureMatrixStore */store) {
			var keys = [];
			_.each(store.data, function(item) {
				keys.push(item.id);
			});

			var req = new PostRequest("LicenseManager", "GetViewFeatureMatrix", {
				OutputJSON: 1,
				Views: keys
			});
			req.post({
				load: lang.hitch(this, this._onFeatureMatrixResponse, store)
			});
		},

		_onFeatureMatrixResponse: function(/* LicenseViewFeatureMatrixStore */store, /* Response */response) {
			_.each(response.data.ATTRIBUTES.Attribute, function(attr) {
				switch (attr.Id) {
					case "Editable":
						this._bEditable = attr.Value;
						break;
					case "FeatureMatrix":
						if (attr.int64) {
							_.each([].concat(attr.int64 || []), function(entry) {
								var bits = entry.$;
								var item = store.get(entry.Key);
								if (item && bits) {
									item.good = (bits & LicenseFeatureMatrix.GOOD_BIT) ? true : false;
									item.better = (bits & LicenseFeatureMatrix.BETTER_BIT) ? true : false;
									item.best = (bits & LicenseFeatureMatrix.BEST_BIT) ? true : false;
									item.development = (bits & LicenseFeatureMatrix.DEVELOPMENT_BIT) ? true : false;
								}
							});
						}
						break;
				}
			}, this);
			this._grid.refresh();
		},

		_updateServerFor: function(item) {
			var bits = (item.good ? LicenseFeatureMatrix.GOOD_BIT : 0) | (item.better ? LicenseFeatureMatrix.BETTER_BIT : 0)
				| (item.best ? LicenseFeatureMatrix.BEST_BIT : 0) | (item.development ? LicenseFeatureMatrix.DEVELOPMENT_BIT : 0);

			this.writeOperations((writer) => {
				writer.callMethod("LicenseManager", "SetViewFeatureMatrix").addParameter("View", "string", item.id).addParameter("Bits", "long", bits);
			});
		},

		_onType: function(/*Controller*/ac) {
			this._typeNode = ac.actionValue;
			this.redraw();
		},

		_onDownloadFeatureMatrix: function(/*ActionController */ac) {
			var request = new GetRequest("LicenseManager", "DownloadFeatureMatrix", {
				OutputJSON: "0"
			});
			csi.browserWindow(request.toRequest(), "FeatureMatrix");
		}
	});
});
